export default __webpack_public_path__ + "static/media/linux.ff969ad1.svg";